import type { EducationItem } from "../types";

export const education: EducationItem[] = [
  {
    id: "tcmc",
    title: {
      en: "Technical College of Management and Commerce",
      ru: "Технический колледж управления и коммерции",
    },
    period: "2013 — 2018",
    summary: {
      en: "Programming in computer systems.",
      ru: "Программирование в компьютерных системах.",
    },
    image: "images/tcmc.jpg",
    link: { label: "tcmc.spb.ru", url: "http://www.tcmc.spb.ru/" },
  },
  {
    id: "worldskills",
    title: { en: "WorldSkills Russia", ru: "WorldSkills Россия" },
    period: "2017",
    summary: {
      en: "Took part as a programmer.",
      ru: "Участвовал как программист.",
    },
    image: "images/worldskills.jpg",
    link: { label: "worldskills.ru", url: "https://worldskills.ru/" },
  },
  {
    id: "sololearn",
    title: {
      en: "SoloLearn — Additional Education",
      ru: "SoloLearn — дополнительное образование",
    },
    summary: {
      en: "Studied the fundamentals of several languages.",
      ru: "Изучал основы нескольких языков.",
    },
    image: "images/sololearn.jpg",
    note: {
      en: "International platform for beginner and experienced programmers to learn and discuss.",
      ru: "Международная платформа, где программисты — и новички, и опытные — учатся и общаются.",
    },
    certificates: [
      {
        label: "HTML Fundamentals",
        url: "https://www.sololearn.com/Certificate/1014-4090103/pdf/",
      },
      {
        label: "CSS Fundamentals",
        url: "https://www.sololearn.com/Certificate/1023-4090103/pdf/",
      },
      {
        label: "JavaScript Tutorial",
        url: "https://www.sololearn.com/Certificate/1024-4090103/pdf/",
      },
      {
        label: "PHP Tutorial",
        url: "https://www.sololearn.com/Certificate/1059-4090103/pdf/",
      },
      {
        label: "jQuery Tutorial",
        url: "https://www.sololearn.com/Certificate/1082-4090103/pdf/",
      },
      {
        label: "Java Tutorial",
        url: "https://www.sololearn.com/Certificate/1068-4090103/pdf/",
      },
      {
        label: "C++ Tutorial",
        url: "https://www.sololearn.com/Certificate/1051-4090103/pdf/",
      },
      {
        label: "Swift 4 Fundamentals",
        url: "https://www.sololearn.com/Certificate/1075-4090103/pdf/",
      },
    ],
  },
];
